<template>
  <li class="grid-item" :class="styles">
    <h2 v-if="icon" class="m-0" :class="iconColor">
      <i :class="icon"></i>
    </h2>
    <p :class="{'m-0 mt-2': icon, 'm-0': noMargin, 'font-weight-bold': strong}" class="card-description text-center">
      <slot></slot>
    </p>
  </li>
</template>
<script>
export default {
  name: "grid-item",
  props: {
    styles: String,
    icon: String,
    iconColor: String,
    items: Array,
    strong: Boolean,
    noMargin: Boolean,
  },
};
</script>
<style></style>
